import { URL_PATH_ES } from 'constants/multiLanguage';
import {
    CREDIT_CARD_PATH,
    VANITY_FAIR_CARD_PATH,
    EL_HORMIGUERO_CARD_PATH,
    CREDIT_CARD_LIGHT_PATH,
    VANITY_FAIR_CARD_LIGHT_PATH,
    EL_HORMIGUERO_CARD_LIGHT_PATH,
} from 'constants/pathInvestments';
import CREDIT_CARD_BASIC from 'assets/images/credit-card-basic-background.svg';
import CREDIT_CARD_VF from 'assets/images/credit-card-vf-background.svg';
import CREDIT_CARD_EH from 'assets/images/credit-card-eh.png';

export const sanetizeCreditCardPath = (path = '') =>
    path.replace(URL_PATH_ES, '').replace(/\/$/, '').replace(/^\//, '');

export const validateCreditCardPath = value => {
    const sanetizedPath = sanetizeCreditCardPath(value);
    const creditCardPaths = [
        CREDIT_CARD_PATH,
        VANITY_FAIR_CARD_PATH,
        EL_HORMIGUERO_CARD_PATH,
        CREDIT_CARD_LIGHT_PATH,
        VANITY_FAIR_CARD_LIGHT_PATH,
        EL_HORMIGUERO_CARD_LIGHT_PATH,
    ];

    return creditCardPaths.includes(sanetizedPath);
};

export const identifyCreditCardPath = value => {
    const sanetizedPath = sanetizeCreditCardPath(value);
    const creditCardPaths = [
        CREDIT_CARD_PATH,
        VANITY_FAIR_CARD_PATH,
        EL_HORMIGUERO_CARD_PATH,
        CREDIT_CARD_LIGHT_PATH,
        VANITY_FAIR_CARD_LIGHT_PATH,
        EL_HORMIGUERO_CARD_LIGHT_PATH,
    ];

    return creditCardPaths.find(path => path === sanetizedPath);
};

export const isCreditCardPath = value => {
    const creditCardLightPaths = [CREDIT_CARD_PATH, VANITY_FAIR_CARD_PATH, EL_HORMIGUERO_CARD_PATH];
    const sanetizedPath = sanetizeCreditCardPath(value);

    return creditCardLightPaths.includes(sanetizedPath);
};
export const isCreditCardPathLight = value => {
    const creditCardLightPaths = [CREDIT_CARD_LIGHT_PATH, VANITY_FAIR_CARD_LIGHT_PATH, EL_HORMIGUERO_CARD_LIGHT_PATH];
    const sanetizedPath = sanetizeCreditCardPath(value);

    return creditCardLightPaths.includes(sanetizedPath);
};

export const getCreditCardLightTypeByPath = path => {
    const sanetizedPath = sanetizeCreditCardPath(path);
    const map = {
        [CREDIT_CARD_LIGHT_PATH]: 'basic',
        [VANITY_FAIR_CARD_LIGHT_PATH]: 'vf',
        [EL_HORMIGUERO_CARD_LIGHT_PATH]: 'eh',
    };

    return map[sanetizedPath] || 'basic';
};

export const getCreditCardImage = partnerId => {
    switch (partnerId) {
        case 'vf':
            return CREDIT_CARD_VF;
        case 'eh':
            return CREDIT_CARD_EH;
        case 'basic':
        default:
            return CREDIT_CARD_BASIC;
    }
};
